import { combineReducers } from "@reduxjs/toolkit";

import memberData from "./memberData/memberData.slice";
import organizationProjects from "./organizationProjects/organizationProjects.slice";

export default combineReducers({
  memberData,
  organizationProjects
});
